const esMessages = {
  common: {
    dashboard: "Tablero",
    edit: "Editar",
    account: "Cuenta",
    one_off: "Formulario Pedido Unico",
    replacement: "Reemplazo",
    parts: "Pedido de Partes",
    refund: "Devolucion",
    refresh: "Recargar",
    devices: "Dispositivos",
    device: "Dispositivo",
    requests: "Solicitudes",
    history: "Historial",
    back_to_search: "Volver a la pagina principal",
    view_all: "Ver todos",
    mac_address: "Dirección Mac",
    timezone_updated: "Zona horaria actualizada con exito",
    language_updated: "Lenguaje actualizado exitosamente",
  },
  locations: {
    title: "Ubicaciones",
    refresh: "Actualizar",
  },
  diagnostics: {
    title: "Diagnóstico",
  },
  devices: {
    title: "Todos los Dispositivos",
  },
  history: {
    title: "Historico",
    events: "Eventos",
    app_activity: "Actividad",
    status_reports: "Reportes de estado",
    setups: "Instalación",
  },
  app_activity: {
    title: "Actividad",
  },
  events: {
    title: "Eventos",
  },
  status_reports: {
    title: "Reportes de estado",
  },
  setups: {
    title: "Instalación",
  },
  authorizations: {
    title: "Autorizaciones",
  },
  device_ownership: {
    title: "Propiedad del Dispositivo",
  },
  customer_transfers: {
    title: "Tranferencias de dispositivos",
  },
  requests: {
    search: "Buscar y Filtrar",
    title: "Todas las Solicitudes",
    refresh: "Recargar",
    list: "Ir al listado",
    uuid: "ID Solicitud",
    type: "Tipo",
    product: "Producto",
    old_product: "Viejo Producto",
    kind: "Producto",
    created: "Creado",
    status: "Estado",
    device_id: "ID Producto",
    old_device_id: "ID Prod. Antiguo",
    agent: "Agente",
    tracking_id: "ID Seguimiento",
    types: {
      replacement: "Reemplazo",
      oneoff: "Pedido unico",
      refund: "Reembolso",
      part: "Partes",
    },
    states: {
      pending: "Pendiente",
      canceled: "Cancelado",
      shipped: "Enviado",
      closed: "Cerrado",
      resolved: "Resuelto",
    },
  },
  details: {
    title: "Información General",
    full_name: "Nombre Completo",
    created_at: "Fecha Creación",
    devices_connected: "Dispositivos Conectados",
    secondary_email: "Email Secundario",
    primary_email: "Email Principal",
    phone: "Número Teléfono",
    referrals: "Código Referidos",
    reset_password: "Resetar Contraseña",
    account_type: "Tipo Cuenta",
  },
  client_devices: {
    title: "Dispositivos conectados",
    app_brand: "Marca",
    hardware_id: "Hardware ID",
    os: "Sistema Operativo",
    signed_in: "Identificado",
    allows_screensharing: "Pantalla Compartida",
  },
  customer_authorizations: {
    title: "Autorizaciones",
    auth_type: "Tipo",
    created_at: "Creada",
    requested_by: "Requerido Por",
    status: "Estado",
  },
  payment_history: {
    date: "Fecha",
    provider: "Proveedor",
    type: "Tipo",
    amount: "Cantidad",
    currency: "Moneda",
    paid: "Captado",
    refunded: "Devuelto",
    card_brand: "Tipo",
    credit_card: "CCard",
    status: "Estado",
  },
  device: {
    title: "Dispositivo",
    general: "Informacion General",
    settings: "Configuraciones",
    events: "Eventos",
    status_reports: "Reportes",
    notes_tags: "Notas/Etiquetas",
    authorizations: "Autorizaciones",
    schedules: "Horarios",
  },
};

export default esMessages;
